import gsap from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

export type AuthHeroNodes = {
  logo: HTMLElement;
  truck: HTMLElement;
  stage: HTMLElement;
  roadLine: SVGPathElement;
};

const truckWidth = (nodes: AuthHeroNodes) => nodes.truck.offsetWidth || 72;

const parkX = (nodes: AuthHeroNodes) => {
  const width = nodes.stage.offsetWidth;
  return Math.max(0, (width - truckWidth(nodes)) / 2);
};

const edgeX = (nodes: AuthHeroNodes) => {
  const width = nodes.stage.offsetWidth;
  return Math.max(24, width - truckWidth(nodes) - 8);
};

export const setAuthHeroEndState = (nodes: AuthHeroNodes) => {
  gsap.set([nodes.logo, nodes.truck], {
    autoAlpha: 1,
    x: 0,
    y: 0,
    scale: 1,
  });
  gsap.set(nodes.truck, { x: parkX(nodes), y: 0 });
  gsap.set(nodes.roadLine, { drawSVG: '0% 100%' });
};

export const playRoadDraw = (nodes: AuthHeroNodes) => {
  const tl = gsap.timeline({ defaults: { duration: 0.4, ease: 'power2.out' } });
  const startX = -truckWidth(nodes);

  gsap.set(nodes.logo, { autoAlpha: 0 });
  gsap.set(nodes.roadLine, { drawSVG: '0% 0%' });
  gsap.set(nodes.truck, { x: startX, autoAlpha: 1 });

  tl.fromTo(nodes.roadLine, { drawSVG: '0% 0%' }, { drawSVG: '0% 100%', duration: 0.75, ease: 'none' });
  tl.fromTo(nodes.truck, { x: startX, autoAlpha: 1 }, { x: edgeX(nodes), duration: 0.75, ease: 'none' }, '<');
  tl.to(nodes.logo, { autoAlpha: 1, duration: 0.24 }, '-=0.2');
  tl.to(nodes.truck, { x: parkX(nodes), duration: 0.36, ease: 'power2.inOut' });
  return tl;
};
